import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-choices',
  templateUrl: './choices.component.html',
  styleUrls: ['./choices.component.css']
})
export class ChoicesComponent implements OnInit {
    prodId;

    public setting?: Setting;

    public itemsListChoices: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadSetting() {
        if (!!this.prodId) {
            this.setting = (await this.datatask.Post(1212, { prod_id: this.prodId }))[0];
        }
    }

    private async loadChoices() {
        if (!!this.prodId) {
            this.itemsListChoices = await this.datatask.Post(1213, { prod_id: this.prodId });
        }
    }

    private async init() {
        this.loadSetting();
        this.loadChoices();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
    prod_id: string;
}
